const childRoutes = (prop) => [
    {
        path: 'trainer-profile',
        name: prop + '.trainer_profile',
        meta: { auth: true },
        component: () => import('../pages/trainer-profile/List.vue')
    },
    {
        path: 'trainer-selection',
        name: prop + '.trainer_selection',
        meta: { auth: true },
        component: () => import('../pages/trainer-selection/List.vue')
    },
    {
        path: 'trainee-profile',
        name: prop + '.trainee_profile',
        meta: { auth: true },
        component: () => import('../pages/trainee-profile/List.vue')
    },
    {
        path: 'trainer-trainee-id-card',
        name: prop + '.trainer_trainee_id_card',
        meta: { auth: true },
        component: () => import('../pages/trainee-id-card/List.vue')
    },
    {
        path: 'trainee-evaluation',
        name: prop + '.trainee_evaluation',
        meta: { auth: true },
        component: () => import('../pages/trainee-evaluation/List.vue')
    },
    {
        path: 'trainee-evaluation-entry',
        name: prop + '.trainee_evaluation_entry',
        meta: { auth: true },
        props: true,
        component: () => import('../pages/trainee-evaluation/Form.vue')
    },
    {
        path: 'trainer-evaluation',
        name: prop + '.trainer_evaluation',
        meta: { auth: true },
        component: () => import('../pages/trainer-evaluation/List.vue')
    },
    {
        path: 'trainer-evaluation-entry',
        name: prop + '.trainer_evaluation_entry',
        meta: { auth: true },
        component: () => import('../pages/trainer-evaluation/Form.vue')
    },
    {
        path: 'release-order',
        name: prop + '.release_order',
        meta: { auth: true },
        component: () => import('../pages/release-order/List.vue')
    },
    {
        path: 'trainer-honorarium',
        name: prop + '.trainer_honorarium',
        meta: { auth: true },
        component: () => import('../pages/trainer-honorarium/List.vue')
    },
    {
        path: 'generate-certificate',
        name: prop + '.generate_certificate',
        meta: { auth: true },
        component: () => import('../pages/generate-certificate/List.vue')
    },
    {
        path: 'generate-certificate-view',
        name: prop + '.generate_certificate_view',
        meta: { auth: true },
        component: () => import('../pages/generate-certificate/View.vue')
    },
    {
        path: 'trainee-allowance',
        name: prop + '.trainee_allowance',
        meta: { auth: true },
        component: () => import('../pages/trainee-allowance/List.vue')
    }
]

const routes = [{
    path: '/training-e-learning-service/trainer-trainee-info-management',
    name: 'training_e_learning_service.trainer_trainee_info_management',
    component: () => import('@/layouts/TrainingElearningLayout.vue'),
    meta: { auth: true },
    children: childRoutes('training_e_learning_service.trainer_trainee_info_management')
}]

export default routes
